import { TaskDTO } from '../api/plyca-dtos';
import { TaskService } from './task.service';
import { Router } from '@angular/router';
import { ServiceLocator } from './../ServiceLocator';
import { OnDestroy, ViewChild, Directive } from '@angular/core';
import {
  taskActionsProcessComponent,
  TaskDTOModal
} from './task.actions.process.component';
import { PlycaDataService } from '../../services/plyca.service';
import { Observable, Subject, throwError } from 'rxjs';
import { DocumentService } from '../documents/document.service';
import { UIService } from '../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { catchError, map, take, tap } from 'rxjs/operators';
import { FormService } from '../components/forms/form.service';
import { formPlycaComponent } from '../components/forms/formPlyca.component';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { ConfirmationService } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';



@Directive()
export class TaskHandler extends BaseComponent implements OnDestroy {
  public task: TaskDTO;
  /**
   * Apertura de tarea en ventana Modal
   */
  // public isModalTaskWindow = false;
  public modalWindowHash: string;
  public route: Router;
  public taskService: TaskService;
  public plycaService: PlycaDataService;
  public documentService: DocumentService;
  public formService: FormService;
  protected validaCierreVentana = true;
  protected isTaskUnlocked = false;
  public uiService: UIService;
  public translateService: TranslateService;
  protected authService: AuthService;
  protected dialogService: DialogService;
  public confirmationService: ConfirmationService;
  protected waitService: WaitLoadingService;
  protected errorHandler: PlycaErrorHandler

  @ViewChild('formPlycaRef') formPlycaRef: formPlycaComponent;



  constructor() {
    super();
    // Se inyectan dependencias. de esta manera evitamos sobrecargar el constructor
    // y en el caso de la herencia no es necesario que las clases hijas establezcan estos parámetros que no necesitan
    this.route = ServiceLocator.injector.get(Router);
    this.taskService = ServiceLocator.injector.get(TaskService);
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.documentService = ServiceLocator.injector.get(DocumentService);
    this.formService = ServiceLocator.injector.get(FormService);
    this.uiService = ServiceLocator.injector.get(UIService);
    this.translateService = ServiceLocator.injector.get(TranslateService);
    this.authService = ServiceLocator.injector.get(AuthService);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);
    this.dialogService = ServiceLocator.injector.get(DialogService);
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);
    this.errorHandler = ServiceLocator.injector.get(PlycaErrorHandler);
  }

  public taskLoaded(): boolean {
    return this.task !== undefined && this.task.work !== undefined;
  }

  processTask(reactivate = false) {
    let subscription = this.processTaskObservable().subscribe();
    this.registerSubscription(subscription);
  }

  saveWorkObservable(reactivate = false): Observable<any> {
    this.waitService.startWaiting();
    return this.taskService.saveWork(this.getTask(), reactivate).pipe(
      map((updatedTask: TaskDTO) => {
        this.formService.merge(this.task, updatedTask);
        // devolvemos la misma instancia de tarea actualizada con updatedTask
        // para mantener sincronizacion de pantallas con el modelo
        return this.task;
      }),
      catchError(err => {
        if (this.formPlycaRef && this.formService.isValidationResponse(err)) {
          this.manageActionError(err, true, false);
        } else {
          this.waitService.cancelWaiting();
          this.errorHandler.showServerError(err);
        }
        return throwError(err);
      })
    );
  }

  processTaskObservableContext(reactivate = false, context?: string): Observable<any> {
    this.waitService.startWaiting();
    return this.saveWorkObservable(reactivate).pipe(
      tap((updatedTask: TaskDTO) => {
        this.waitService.startWaiting('Tarea completada, cargando acciones...');
        this.openModal();
      }
      ));
  }

  processTaskObservable(reactivate = false): Observable<any> {
    this.waitService.startWaiting();
    return this.saveWorkObservable(reactivate).pipe(
      tap((updatedTask: TaskDTO) => {
        this.waitService.startWaiting('Tarea completada, cargando acciones...');
        this.openModal();
      }
      ));
  }

  isStatelessTask() {
    if (this.task['taskData']) {
      let statelessProperty = this.task['taskData'].filter((prop) => prop.name === 'TAREA_CON_ESTADO');
      // tslint:disable-next-line:triple-equals
      if (statelessProperty.length > 0 && statelessProperty[0].value && statelessProperty[0].value.toLowerCase() == 'false') {
        return true;
      }
    }
    return false;
  }

  openModal(fixedAction?: any): void {
    this.waitService.startWaiting();
    let context = new TaskDTOModal(this.task, fixedAction);

    let config: DynamicDialogConfig = {
      header: ' ',
      width: '50%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = context;

    let ref = this.dialogService.open(taskActionsProcessComponent, config);

    ref.onClose.pipe(take(1)).subscribe(result => {

      if (result) {
        if (result.success) {
          // this.waitService.startWaiting();
          this.validaCierreVentana = false;
          this.isTaskUnlocked = true;
          //          this.route.navigate(['tasks']);
          this.salir();
        } else {
          this.waitService.cancelWaiting();
          this.uiService.showMessage(result.message);
        }
      }
    });
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {

    // si hay que validar el cierre, pedimos confirmacion al usuario
    if (this.authService.isLoggedIn() && !this.isTaskUnlocked) {




      let confirmSelection = new Subject<boolean>();
      if (this.validaCierreVentana) {

        // Excluimos la confirmación para las tareas de mensaje que no tienen selección de opciones
        if (this.task.workType === 'MESSAGE' && !this.task.work.options) {
          this.waitService.startWaiting();
          this.subscribe(this.taskService.unlockTask(this.getTask(), false),
            undefined,
            undefined,
            () => {
              this.validaCierreVentana = false;
              this.isTaskUnlocked = true;
              confirmSelection.next(true);
              this.waitService.cancelWaiting();
            });
        } else {
          this.confirmationService.confirm({
            message: this.translateService.instant('General.discard.changes'),
            acceptLabel: this.translateService.instant('General.discard.accept'),
            rejectLabel: this.translateService.instant('General.discard.cancel'),
            accept: () => {
              this.waitService.startWaiting();
              this.subscribe(this.taskService.unlockTask(this.getTask(), false),
                undefined,
                undefined,
                () => {
                  this.validaCierreVentana = false;
                  this.isTaskUnlocked = true;
                  confirmSelection.next(true);
                  this.waitService.cancelWaiting();
                });
            },
            reject: () => { confirmSelection.next(false) }
          });
        }

      } else {
        this.waitService.startWaiting();
        this.subscribe(this.taskService.unlockTask(this.getTask(), false),
          undefined,
          undefined,
          () => {
            this.validaCierreVentana = false;
            this.isTaskUnlocked = true;
            confirmSelection.next(true);
            this.waitService.cancelWaiting();
          });
      }
      return confirmSelection;
    }
    return true;
  }

  salir() {
    this.uiService.routeBack();
  }


  ngOnDestroy(): void {
    if (this.modalWindowHash && this.taskService.isLockedTask(this.task)) {
      this.subscribe(this.taskService.unlockTask(this.task));
      // } else {
      //   this.waitService.cancelWaiting();
    }
    super.ngOnDestroy();
  }


  protected getTask(): TaskDTO {
    return this.task;
  }

  protected manageActionError(
    error: any,
    cancelWait = true,
    showMessage = true
  ): void {
    if (cancelWait) {
      this.waitService.cancelWaiting();
    }

    if (this.formPlycaRef) {
      this.formPlycaRef.deleteFormErrors();
      this.formPlycaRef.manageFormException(error, showMessage);
    } else {
      this.modalError(error);
    }
  }

  modalError(error: any) { }

}
